import log from 'loglevel';
log.setLevel('info');
log.setLevel('trace');

export const BotLogger = log;
